import { EABError } from 'core-js-error';
import { ContentTabViewController, ContentTabViewComponent } from './content_tab_view/content_tab_view';

angular
  .module('ui-ng-content-tabs', [])
  .component('contentTabView', new ContentTabViewComponent())
  .controller('ContentTabViewController', ContentTabViewController);

export * from './types/tab_enum_type';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-content-tabs/src/main.ts